import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';

import Popup from 'reactjs-popup';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Moment from 'react-moment';
import moment from 'moment';
import ReactToPrint from 'react-to-print';

import ReactHTMLTableToExcel from 'react-html-table-to-excel';
const headCells = [
  
  { id: 'ldm_firstname ldm_middlename ldm_lastname', numeric: false, label: 'Name' },
  { id: 'ldm_emailid', numeric: false, label: 'Email ID' },
  { id: 'ldm_phoneno', numeric: false, label: 'Phone No.' },
     { id: 'gender', numeric: false, label: 'Gender' },
    { id: 'ldm_address', numeric: false, label: 'Address' },
	 { id: 'enquirydate', numeric: false, label: 'Enquired On' },
    { id: 'Type', numeric: false, label: 'Status' },
	 { id: 'followupdate', numeric: false, label: 'Followup Date' },
{ id: 'leadesource', numeric: false, label: 'Source' },
{ id: 'ls_comments', numeric: false, label: 'Comments' },
{ id: 'reason', numeric: false, label: 'Reason' },
{ id: 'ls_movedtoaddress', numeric: false, label: 'Moved Location' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
const style = ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
});

export default class Leadmasterreport extends Component {
	
			constructor(props) {
    super(props);
	
	const now = dayjs();
const startOfMonth = now.startOf('month');
const today = now;

	this.state = {edirect: false,
      Leadmasterdata:[],ldmid:'',page: 0 ,exportdata:[],prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',names:'',searchsubscription:'',type:'', 
	  //fromdate:dayjs(Date.now()),fromdate1:'',todate:dayjs(Date.now()),todate1:'',
	  fromdate: startOfMonth,
  fromdate1: startOfMonth.format('YYYY-MM-DD'),
  todate: today,
  todate1: today.format('YYYY-MM-DD'),
    }
      
	  };
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  
  
  
  this.setState({[nam]: val});

 } 
  handleClickSearch=()=>{    
  this.apicall(this.state.page,this.state.rowsPerPage);	
} 
	componentDidMount  () {	
	
	
	document.title = "AthaYog Living - Lead Master Report";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }

  this.apicall(this.state.page,this.state.rowsPerPage);
  
} 

	
apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxreport.php?action=leadmasterreport&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&ldm_firstname='+this.state.names+'&ldm_type='+this.state.type+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  Leadmasterdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
			   

		    });
	  
	 
	 this.exportapicall();
     }
	 else{
		   this.setState({Leadmasterdata:[],totaldata:0});
	 }
 
    });
}
	
exportapicall(){
	 
	 axios.get(Serverurl+'ajaxreport.php?action=leadmasterreport&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&ldm_firstname='+this.state.names+'&ldm_type='+this.state.type)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  exportdata: resp.data,  
			
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({exportdata:[],totaldata:0});
	 }
 
    });
}
handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
	  
handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 
	 todate1.setDate(date1.getDate() + 1);
	
     this.setState({ fromdate:dayjs(date),
fromdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
todate: todate1,
todate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
	
	
  }
  handtodateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ todate:dayjs(date),
todate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
  

<div className="boxheading">
				 
<h2>Leads Report</h2>
</div>

<div className="clear">
</div>

   <div className="searchmaster">


  
  <ul>
  <li>
 <p>From Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
className="txtbox" 
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 
  <li>
 <p>To Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="txtbox" 
    onChange={this.handtodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 <li>
 <p>Name</p>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
			placeholder="Name"
            name="names" onChange={this.myChangeHandler}
		
          /></p></li>
		
	<li>
	 <p>Type</p>
	<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler} className="txtbox"
          id="type"
		   value={this.state.type} inputProps={{tabIndex: "2"}}
		  name="type"
		
        >
	
	<option value="">Select Type</option>
           <option value={1}>Active</option>
          <option value={2}>In Active</option>
 <option value={3}>Follow Up</option>
 <option value={4}>Enquiry</option>
 <option value={5}>Lost</option>

        </Select>

		</FormControl>
		</p>
	</li>		
		
		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	<ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="leadmasterreport"
							filename="Lead Master Report"
							sheet="Lead Master Report"
							buttonText="EXPORT"/>&nbsp;&nbsp;

	  
	  </p></li> 
		
		
		
		
		</ul>
		
</div>		


<div ref={el => (this.componentRef = el)}  >

<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" >  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Leadmasterdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Leadmasterdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >


<TableCell>{item.ldm_firstname} {item.ldm_middlename} {item.ldm_lastname}</TableCell>
<TableCell>{item.ldm_emailid}</TableCell>
<TableCell>{item.ldm_phoneno}</TableCell>
<TableCell>{item.gender}</TableCell><TableCell>{item.ldm_address}</TableCell><TableCell>{item.enquirydate}</TableCell>

<TableCell>{item.type}</TableCell>
<TableCell>{item.followupdate}</TableCell>

<TableCell>{item.leadesource}</TableCell>
<TableCell>{item.ls_comments}</TableCell>
<TableCell>{item.reason}</TableCell>
<TableCell>{item.ls_movedtoaddress}</TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
   <TablePagination  
       
        rowsPerPageOptions={[50,100,200,300,400]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}   
      />    
  </Paper>
</div>



<div style={{"display":"none"}}>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="leadmasterreport">  
<TableHead> 
<TableRow>
                                        
     <TableCell>Name   </TableCell>               
		<TableCell>Email Id   </TableCell> 
<TableCell>Phone No.   </TableCell>  
<TableCell>Gender  </TableCell> 
<TableCell>Address  </TableCell> 
<TableCell>DOB  </TableCell>  
<TableCell>Enquiry Date  </TableCell> 
<TableCell>Referred By  </TableCell>   
 
<TableCell>Status  </TableCell> 
<TableCell>Follow Up date  </TableCell> 
<TableCell>Source  </TableCell> 	
<TableCell>Comments  </TableCell> 
<TableCell>Reason  </TableCell> 
<TableCell>Moved Location  </TableCell> 
	<TableCell>Yoga Trainer  </TableCell> 	

                      </TableRow></TableHead>
					  
					   
                      <TableBody>
                     {this.state.exportdata.map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.ldm_firstname} {item.ldm_middlename} {item.ldm_lastname}</TableCell>
<TableCell>{item.ldm_emailid}</TableCell>
<TableCell>{item.ldm_phoneno}</TableCell>
<TableCell>{item.gender}</TableCell><TableCell>{item.ldm_address}</TableCell>
<TableCell>{item.Dob}</TableCell>
<TableCell>{item.enquirydate}</TableCell>
<TableCell>{item.ldm_referby}</TableCell>

<TableCell>{item.type}</TableCell>
<TableCell>{item.followupdate}</TableCell>
<TableCell>{item.leadesource}</TableCell>
<TableCell>{item.ldm_comments}</TableCell>
<TableCell>{item.reason}</TableCell>
<TableCell>{item.ls_movedtoaddress}</TableCell>
<TableCell>{item.st_name}</TableCell>

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
   
  </Paper></div>
 </React.Fragment> 

 
 
  );
}
	
	
}

  